import React, { useEffect, useState } from "react";
import {
  CardMedia,
  Card,
  CardActions,
  Button,
  CardContent,
  Typography,
  FormControl,
  FormControlLabel,
  RadioGroup,
  FormLabel,
  Radio,
} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import TutorialComponent from "./videoHelper/index.jsx";
import TutorialHolder from "./videoHelper/TutorialHolder.jsx"
import { useStyles } from "./MuiCssStyle/MUiStyle.jsx";
const contentLoaders = [
  {
    key: "tutorialVideo",
    label: "Tutorial",
  
  },
  {
    key: "helperDocs",
    label: "Documents",
  },
  {
    key: "others",
    label: "Others",
  },
];
const defaultCon=[{ value: "tutorialVideo", label: "Tutorial",
  videoURL:"",
  text:"",
  title:""
 }]
const HelperIcon = ({
  closeHandler,
  contentController = defaultCon,
  defaultSelector = "tutorialVideo",
}) => {
  const styles=useStyles()
  const [contentloader, setContentLoader] = useState(<div />);

  useEffect(() => {
    contentController.forEach((content)=>{
      if(defaultSelector.localeCompare(content.value)==0)
         selectorMatcher(defaultSelector,content);
    })
    
  }, []);
  const componentLoader = (toMatch,propsValue) => {
    selectorMatcher(toMatch.target.value,propsValue);
  };

  const selectorMatcher = (toMatch,propsValue) => {

    switch (toMatch) {
      case contentLoaders[0].key:
        setContentLoader(<TutorialHolder listOfHelper={propsValue.tutorials}/>);
        break;
      case contentLoaders[1].key:
        setContentLoader(<div>Docs</div>);
        break;
      case contentLoaders[2].key:
        setContentLoader(null);
        break;
      default:
        setContentLoader(<div>Cannot not found the selector</div>);
    }
  };

  return (
    <Box
      className={styles.MainHelper}
    >
      <Box
        sx={{
          display:"block",
          width: "100%",
        }}
      >
        <Button
          onClick={() => {
            closeHandler(false);
          }}
          style={{ float: "right" }}
          variant="outlined"
          color="secondary"
        >
          Close
        </Button>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <FormControl>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            defaultValue={defaultSelector}
          >
            {contentController.map((content, index) => (
              <FormControlLabel
                key={index}
                value={content.value}
                control={<Radio />}
                label={content.label}
                onChange={(values)=>componentLoader(values,content)}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Box>
      {contentloader}
    </Box>
  );
};

export default HelperIcon;
